<form [formGroup]="form" class="flex column start center w-100 g-16" (ngSubmit)="change()">
	<h4>{{ 'account.password' | translateWithKeys }}</h4>
	<mat-form-field appearance="outline" class="w-100">
		<input matInput [type]="visibility.currentPassword ? 'text' : 'password'" [placeholder]="'account.current_password' | translateWithKeys" formControlName="currentPassword" name="currentPassword">
		<mat-icon matSuffix [svgIcon]="visibility.currentPassword ? 'visibility_off' : 'visibility'"
                    (click)="toggleVisibility('currentPassword')" class="pointer"></mat-icon>
		<mat-error>{{ errors?.['currentPassword'] | translateWithKeys }}</mat-error>
	</mat-form-field>
	<div class="flex column start center w-100">
		<p class="m-0">{{ 'account.new_password' | translateWithKeys }}</p>
		<p class="title2">{{ 'account.password_must_have' | translateWithKeys }}</p>
		<mat-form-field appearance="outline" class="w-100">
			<input matInput [type]="visibility.newPassword ? 'text' : 'password'" [placeholder]="'account.new_password' | translateWithKeys" formControlName="newPassword" name="newPassword">
			<mat-icon matSuffix [svgIcon]="visibility.newPassword ? 'visibility_off' : 'visibility'"
                    (click)="toggleVisibility('newPassword')" class="pointer"></mat-icon>
			<mat-error>{{ errors?.['newPassword'] | translateWithKeys:{ params: { amount: MIN_AMOUNT_OF_CHARACTERS } } }}</mat-error>
		</mat-form-field>
	</div>
	<mat-form-field appearance="outline" class="w-100">
		<input matInput [type]="visibility.confirmNewPassword ? 'text' : 'password'" [placeholder]="'account.confirm_new_password' | translateWithKeys" formControlName="confirmNewPassword" name="confirmNewPassword">
		@if (!errors?.['confirmNewPassword']) {
			<mat-icon matSuffix [ngClass]="{'check-icon': form.value?.newPassword === form.value?.confirmNewPassword && form.value?.newPassword && form.value?.confirmNewPassword}"
			svgIcon="check_rounded"></mat-icon>
		} @else {
			<mat-icon matSuffix [svgIcon]="visibility.confirmNewPassword ? 'visibility_off' : 'visibility'"
                    (click)="toggleVisibility('confirmNewPassword')" class="pointer"></mat-icon>
		}
		<mat-error>
			{{ errors?.['confirmNewPassword'] | translateWithKeys }}
		</mat-error>
	</mat-form-field>
	<button mat-flat-button class="bg-primary-darker text-accent-lighter button" type="submit" [disabled]="form.invalid || submitting">
		{{ 'account.change' | translateWithKeys }}
	</button>
</form>
